import { LastSearchCard } from '../../../components/PageWrappers/SharedComponents/LastSearchCard/LastSearchCard';
import { TabSelector } from '../../../components/Toolkit/TabSelector/TabSelector';
import { media } from '../../../helpers/breakpoints';
import styled from 'styled-components';

export const HomePageWrapper = styled.main``;

export const WhiteSection = styled.div`
  background-color: ${({ theme }) => theme.colors.WHITE};
`;

export const LifeStyleSection = styled.div`
  margin: ${({ theme }) => theme.spacing.M24} 0;
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

export const Heading = styled.h2`
  ${({ theme }) => theme.fontSize.L18};
`;

export const HomePageUnit = styled.div`
  background-color: ${({ theme }) => theme.colors.WHITE};
  padding: ${({ theme }) => theme.spacing.S8} 0;

  ${media.large} {
    padding: ${({ theme }) => theme.spacing.M16} 0 0 0;
  }

  ${media.smallOnly} {
    order: 1;
  }
`;

export const UnitContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;

  ${media.large} {
    padding: 0 ${({ theme }) => theme.spacing.M16};
  }
`;

export const FlexReordering = styled.div`
  display: flex;
  flex-direction: column;

  .set-width-100 {
    width: 100%;
  }
`;

export const Container = styled.div<{ isCarousel?: boolean }>`
  padding: ${({ theme, isCarousel }) =>
    isCarousel ? `${theme.spacing.M16} 0` : theme.spacing.M16};
  ${media.medium} {
    padding: ${({ theme }) => theme.spacing.M24} 0;
  }

  ${media.smallOnly} {
    ${({ isCarousel, theme }) =>
      isCarousel
        ? `
      ${Heading} {
        margin-left: ${theme.spacing.M16}
      }
    `
        : ''}
  }
`;

export const HeroContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${media.large} {
    align-items: flex-start;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const HeroContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  padding: var(--hero-search-form-padding);
  border-radius: ${({ theme }) => theme.borderRadius.large};
  box-shadow: ${({ theme }) => theme.shadow.LARGE};
  max-width: 448px;
`;

export const HeroTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.M16};
  padding: ${({ theme }) =>
    `0 ${theme.spacing.M16} ${theme.spacing.M16} ${theme.spacing.M16}`};

  ${media.medium} {
    padding: ${({ theme }) =>
      `0 ${theme.spacing.M32} ${theme.spacing.M16} ${theme.spacing.M32}`};
  }

  ${media.large} {
    padding-top: 80px;
    padding-right: ${({ theme }) => theme.spacing.S8};
    padding-left: 0;
  }
`;

export const HeroTitle = styled.h1`
  width: 100%;
  max-width: 350px;
  color: ${({ theme }) => theme.colors.WHITE};
  ${({ theme }) => theme.fontSize.H28};
  font-weight: ${({ theme }) => theme.fontWeight.extraBold};
  text-align: center;

  ${media.large} {
    ${({ theme }) => theme.fontSize.H48};
    max-width: 100%;
    text-align: left;
  }

  // If we set the font size to H64, the text goes on 3 rows (when the media screen is between 64 and 76em)
  @media screen and (min-width: 76em) {
    ${({ theme }) => theme.fontSize.H64};
  }
`;

export const STabSelector = styled(TabSelector)`
  margin: 0 auto ${({ theme }) => theme.spacing.M16};

  ${media.large} {
    margin: 0 auto ${({ theme }) => theme.spacing.M24};
  }
`;

interface ISectionBrowserHeight {
  focus: string;
  hasSections: boolean;
}
export const SectionBrowserHeight = styled.div<ISectionBrowserHeight>`
  min-height: ${({ focus, hasSections }) =>
    hasSections ? (focus === 'motor' ? '480px' : '380px') : '50px'};
`;

export const SLinkPadding = styled.div`
  ${media.smallOnly} {
    padding: ${({ theme }) => `0 ${theme.spacing.M16}`};
  }
`;

export const StyledLastSearchCard = styled(LastSearchCard)`
  margin-bottom: ${({ theme }) => theme.spacing.M16};

  ${media.large} {
    display: none;
  }
`;
